<template>
    <div class="z-index-0">
        <div class="row">
            <div class="col-xl-5 col-12 p-0">
                <div class="h1 labgrotesque-bold text-xl-center text-left px-xl-0 px-4">
                    {{ $t($route.meta.title) }}
                    <hr class="hr-title-mobile">
                </div>
            </div>

            <div class="col-xl-7 col-12 px-xl-0 px-4">
                <div class="labgrotesque-bold" id="numbers">
                    <ul>
                        <li class="" v-for="(number, index) in numbers" :id="'li-number-' + index" class="d-inline-block d-xl-block" @click="selectNumber('number-' + index)">
                            <div class="line-numbers d-inline-block" v-if="$root.getClassSize() === 'xl'"></div>
                            <h2 class="d-inline-block mb-0" v-html="number.title"></h2>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <template v-if="numbers.length > 0 && $root.getClassSize() === 'xl'">
            <template v-for="(number, index) in numbers">
                <div class="numbers noactive" :id="'number-' + index" @click="selectNumber('number-' + index)">
                    {{ parseFloat(number.field_numeri_valore) }}
                </div>

                <div class="numbers d-none active" :id="'number-' + index + '-active'">
                    {{ parseFloat(number.field_numeri_valore) }}
                </div>

                <div class="numbers-body d-none" v-html="number.body" :id="'number-' + index + '-body'"></div>
            </template>
        </template>

        <template v-else>
            <template v-for="(number, index) in numbers">
                <div class="px-4">
                    <div class="numbers d-none" :id="'number-' + index">
                        {{ parseFloat(number.field_numeri_valore) }}
                    </div>

                    <div class="numbers-body d-none" v-html="number.body" :id="'number-' + index + '-body'"></div>
                </div>
            </template>
        </template>
    </div>
</template>

<script>
export default {
    name: "numbers",

    data() {
        return {
            numbers: [],
            numberactive: null,
            canselectnumber: true
        }
    },

    created() {
        this.$root.animejs.resetAnimations();

        axios.get(this.$route.meta.api + "/" + this.$root.getLanguage(), this.$root.auth)
        .then(response => {
            this.numbers = response.data;

            this.$nextTick(function() {
                if(this.$root.getClassSize() === 'xl') {
                    this.resetAnimation();
                    this.initAnimation();
                }
            });
        });
    },

    methods: {
        resetAnimation() {
            var thisObj = this;
            $(".numbers").each(function() {
                var id = $(this).attr("id");
                thisObj.$root.animejs.removeAnimationById(id);
            });
        },

        initAnimation() {
            var thisObj = this;

            var width = $(window).width();
            var height = $(window).height();

            var countDelay = 0;
            var numbersAnimation = this.$root.animejs.timeline({
                loop: true,
                loopComplete: function(anim) {
                    thisObj.deselectNumber();
                    
                    $(".numbers").each(function(index) {
                        var id = $(this).attr("id");                        
                        var widthNumber = $('#' + id).width();
                        var x = thisObj.$root.animejs.random(0, width - widthNumber);
                        $('#' + id).css({"left": x, "top": height, "opacity": 1});
                    });
                }
            });
            $(".numbers").each(function(index) {
                var id = $(this).attr("id");
                
                var widthNumber = $('#' + id).width();
                var heightNumber = $('#' + id).height();
                var x = thisObj.$root.animejs.random(0, width - widthNumber);
                var duration = height/0.1;

                $('#' + id).css("left", x);
                $('#' + id).css("top", height);

                var delay = index % 2 == 0 ? countDelay : 0;
                numbersAnimation.add({
                    targets: '#' + id,
                    top: -heightNumber,
                    opacity: 0.2,
                    easing: 'linear',
                    duration: duration,
                    /*complete: function(anim) {
                        var x = thisObj.$root.animejs.random(0, width - widthNumber);
                        $('#' + id).css({"left": x, "top": height, "opacity": 1});
                    }*/
                }, delay);

                countDelay += 1000;
            });
        },

        selectNumber(id) {
            if(this.canselectnumber) {
                if(id != this.numberactive) {
                    var thisObj = this;
                    if(this.$root.getClassSize() === 'xl') {
                        this.$root.animejs.remove("#" + id + "-active");

                        var positionListNumbers = $("#numbers").offset();
                        var heightListNumbers = $("#numbers").height();

                        var width = $(window).width();
                        var widthNumber = $('#' + id).width();
                        var height = $(window).height();
                        var heightNumber = $('#' + id).height();

                        var left = $("#" + id).css("left");
                        var leftActive = positionListNumbers.left; //width/2 - (widthNumber/2);
                        var top = $("#" + id).css("top");
                        var topActive = positionListNumbers.top + heightListNumbers; //height/2 - (heightNumber/2);
                        
                        this.$root.animejs({
                            targets: '#' + id + '-active',
                            opacity: 1,
                            easing: 'easeInOutExpo',
                            left: [left, leftActive],
                            top: [top, topActive],
                            color: '#e30613',
                            duration: 500,
                            begin: function(anim) {
                                $("#li-" + id).addClass("active");
                                $("#" + id).addClass("d-none");
                                $("#" + id + "-active").removeClass("d-none");

                                if(thisObj.numberactive) {
                                    thisObj.deselectNumber();
                                }

                                thisObj.canselectnumber = false;
                            },
                            complete: function(anim) {
                                thisObj.numberactive = id;

                                $("#" + id + "-body").css("left", leftActive + widthNumber);
                                $("#" + id + "-body").css("top", topActive);
                                $("#" + id + "-body").removeClass("d-none");

                                thisObj.canselectnumber = true;
                            }
                        });
                    }
                    else {
                        $("#numbers li").removeClass("active");
                        $("#li-" + id).addClass("active");

                        this.$root.animejs({
                            targets: '#' + id + ', #' + id + '-body',
                            opacity: [0, 1],
                            easing: 'easeInOutExpo',
                            duration: 500,
                            begin: function(anim) {
                                $("#" + thisObj.numberactive + ", #" + thisObj.numberactive + "-body").addClass("d-none");
                                $("#" + id + ", #" + id + "-body").removeClass("d-none");
                                thisObj.numberactive = id;

                                thisObj.canselectnumber = false;
                            },
                            complete: function(anim) {
                                thisObj.canselectnumber = true;
                            }
                        });
                    }
                }
            }
        },

        deselectNumber() {
            var id = this.numberactive;
            var leftActive = $("#" + id + "-active").css("left");
            var left = $("#" + id).css("left");
            var topActive = $("#" + id + "-active").css("top");
            var top = $("#" + id).css("top");

            var thisObj = this;
            this.$root.animejs({
                targets: '#' + id + '-active',
                opacity: [1, 0],
                easing: 'easeInOutExpo',
                left: [leftActive, left],
                top: [topActive, top],
                color: '#e6e6e6',
                duration: 500,
                begin: function(anim) {
                    $("#li-" + id).removeClass("active");
                    $("#" + id).removeClass("d-none");

                    $(".numbers-body").addClass("d-none");
                },
                complete: function(anim) {
                    $("#" + id + "-active").addClass("d-none");
                },
            });
        }        
    }
}
</script>


// WEBPACK FOOTER //
// src/components/pages/numbers.vue